import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import {
  getVehicleImagePngFallback,
  VEHICLE_IMAGE_PLACEHOLDER,
} from "../data/vehicles";

const VehicleCard = ({
  imageUrl,
  vehicleName,
  perDayPrice,
  priority = false,
}) => {
  const [src, setSrc] = useState(imageUrl || VEHICLE_IMAGE_PLACEHOLDER);
  const pngFallback = getVehicleImagePngFallback(src);

  useEffect(() => {
    setSrc(imageUrl || VEHICLE_IMAGE_PLACEHOLDER);
  }, [imageUrl]);

  const handleError = () => {
    if (pngFallback && src !== pngFallback) {
      setSrc(pngFallback);
      return;
    }
    if (src !== VEHICLE_IMAGE_PLACEHOLDER) {
      setSrc(VEHICLE_IMAGE_PLACEHOLDER);
    }
  };

  return (
    <article className='vehicleCard'>
      <div className='vehicleCard-image'>
        <img
          className='vehicleCard-img'
          src={src}
          alt={vehicleName}
          width={600}
          height={400}
          loading={priority ? "eager" : "lazy"}
          decoding={priority ? "sync" : "async"}
          fetchPriority={priority ? "high" : "low"}
          onError={handleError}
        />
      </div>
      <div className='vehicleCard-price'>
        <p className='card__title'>{vehicleName}</p>
        <Typography className='per-day-price' component='p'>
          <span>FROM</span> <span>${perDayPrice}</span> / WEEK
        </Typography>
      </div>
    </article>
  );
};

export default VehicleCard;
